import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

class PageContent extends Component {
    static propTypes = {
        children: PropTypes.any.isRequired,
        className: PropTypes.string
    };

    render() {
        const { children, className = '' } = this.props;
        const classNames = cns({ pageContent: !className.includes('adminWrapper') }, 'container', className);
        return <div className={classNames}>{children}</div>;
    }
}

export default PageContent;
